// extracted by mini-css-extract-plugin
export var errorIcon = "_kr-1";
export var nameLogo = "_kr-0";